const React = require('react');
const PropTypes = require('prop-types');

class Label extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        value: PropTypes.string,
        suppressNewline: PropTypes.bool
    };

    render() {
        "use strict";

        // Provide the ability to set override classes to the div element for custom styling
        const styleClass = this.props.overrideClass ? ' ' + this.props.overrideClass : "control-label";
        const display = this.props.suppressNewline ? 'inline' : 'block';

        return (
            <div style={{display: display}}>
                <label className={styleClass}>
                    {this.props.title}&nbsp;&nbsp;
                </label>
                {this.props.value && (
                    <span>
                        {this.props.value}
                    </span>
                )}
            </div>
        );
    }
}

module.exports = Label;
